import React from 'react';
import { useDispatch } from 'react-redux';
import { setLastChangedFilter } from '../../../../appSlice';
import { WHERE_FILTER_UPDATE_EVENT } from '../../../../constants/analyticEvents';
import { pushEvent } from '../../../../utilities/analytics';
import { clearSelectedHotel } from '../../../search/searchSlice';
import { updateMainFilter } from '../../mainFilterSlice';
import Destination from './Destination';
import useGetFilteredByWhatDestinations from './useGetFilteredByWhatDestinations';
import useSearchPerformed from '../../../../hooks/useSearchPerformed';

const DestinationFilter = ({addFilterToSet}) => {
  const dispatch = useDispatch();
  const { destinations, setDestinations, destinationsGroups, setDestinationsGroups } =
    useGetFilteredByWhatDestinations();
  const [setAppTimeout] = useSearchPerformed();

  const onSave = ({ destinations, destinationsGroups }) => {
    dispatch(
      updateMainFilter({
        updatedValue: {
          destinations,
          destinationsGroups,
        },
        filter: 'where',
      })
    );
    dispatch(clearSelectedHotel());
    dispatch(setLastChangedFilter('where'));

    pushEvent(WHERE_FILTER_UPDATE_EVENT, {
      destinations,
      destinationsGroups,
    });
    setAppTimeout(7000);
  };

  window.external_set_destinations = (destinationObject) => {
    // window.external_set_destinations({destinations: [27,28], destinationsGroups: [10] })
    addFilterToSet(() => {
      const oldDestinations = destinations;
      const oldDestinationsGroups = destinationsGroups;

      const updatedDestinationsGroups = oldDestinationsGroups.map((item) => ({
        ...item,
        active: destinationObject.destinationsGroups.includes(item.id),
      }));

      const updatedDestinations = oldDestinations
        .map((item) => ({
          ...item,
          active: destinationObject.destinations.includes(item.id),
        }))
        .map((destination) => {
          if (!Array.isArray(destination.destinations_groups)) return destination;

          const isActiveInDestinationGroup = updatedDestinationsGroups
            .filter(({ active }) => active)
            .some((group) => destination.destinations_groups.some((id) => id === group.id));

          return {
            ...destination,
            active: isActiveInDestinationGroup || destination.active,
          };
        });

      dispatch(
        updateMainFilter({
          updatedValue: {
            destinations: updatedDestinations,
            destinationsGroups: updatedDestinationsGroups,
          },
          filter: 'where',
        })
      );
      dispatch(clearSelectedHotel());
      dispatch(setLastChangedFilter('where'));

      pushEvent(WHERE_FILTER_UPDATE_EVENT, {
        destinations: updatedDestinations,
        destinationsGroups: updatedDestinationsGroups,
      });
      setAppTimeout(7000);
    });
  };

  const handleClear = (updatedValue) => {
    dispatch(
      updateMainFilter({
        filter: 'where',
        updatedValue,
      })
    );
  };

  return (
    <Destination
      onSave={onSave}
      onClear={handleClear}
      destinations={destinations}
      setDestinations={setDestinations}
      destinationsGroups={destinationsGroups}
      setDestinationsGroups={setDestinationsGroups}
      addFilterToSet={addFilterToSet}
    />
  );
};

export default React.memo(DestinationFilter);
